import { FunctionComponent, SVGProps } from "react";

import {
  LogoCloudformation,
  LogoKubernetes,
  LogoAnsible,
  LogoOpentofu,
  LogoPulumi,
  LogoTerraform,
  LogoTerragrunt,
} from "components/icons/generated";

// TODO: [dashboard] those colors will be changed because of accessibility issues
export const vendors: Record<
  string,
  {
    logo: FunctionComponent<SVGProps<SVGSVGElement>>;
    color: string;
    activeColor: string;
    inactiveColor: string;
  }
> = {
  Terraform: {
    logo: LogoTerraform,
    color: "var(--semantic-color-background-interactive-data-vendor-terraform-rest)",
    activeColor: "var(--semantic-color-background-interactive-data-vendor-terraform-hovered)",
    inactiveColor: "var(--semantic-color-background-interactive-data-vendor-terraform-inactive)",
  },
  Ansible: {
    logo: LogoAnsible,
    color: "var(--semantic-color-background-interactive-data-vendor-ansible-rest)",
    activeColor: "var(--semantic-color-background-interactive-data-vendor-ansible-hovered)",
    inactiveColor: "var(--semantic-color-background-interactive-data-vendor-ansible-inactive)",
  },
  CloudFormation: {
    logo: LogoCloudformation,
    color: "var(--semantic-color-background-interactive-data-vendor-cloudformation-rest)",
    activeColor: "var(--semantic-color-background-interactive-data-vendor-cloudformation-hovered)",
    inactiveColor:
      "var(--semantic-color-background-interactive-data-vendor-cloudformation-inactive)",
  },
  Kubernetes: {
    logo: LogoKubernetes,
    color: "var(--semantic-color-background-interactive-data-vendor-kubernetes-rest)",
    activeColor: "var(--semantic-color-background-interactive-data-vendor-kubernetes-hovered)",
    inactiveColor: "var(--semantic-color-background-interactive-data-vendor-kubernetes-inactive)",
  },
  Pulumi: {
    logo: LogoPulumi,
    color: "var(--semantic-color-background-interactive-data-vendor-pulumi-rest)",
    activeColor: "var(--semantic-color-background-interactive-data-vendor-pulumi-hovered)",
    inactiveColor: "var(--semantic-color-background-interactive-data-vendor-pulumi-inactive)",
  },
  OpenTofu: {
    logo: LogoOpentofu,
    color: "var(--semantic-color-background-interactive-data-vendor-opentofu-rest)",
    activeColor: "var(--semantic-color-background-interactive-data-vendor-opentofu-hovered)",
    inactiveColor: "var(--semantic-color-background-interactive-data-vendor-opentofu-inactive)",
  },
  Terragrunt: {
    logo: LogoTerragrunt,
    color: "var(--semantic-color-background-interactive-data-vendor-terragrunt-rest)",
    activeColor: "var(--semantic-color-background-interactive-data-vendor-terragrunt-hovered)",
    inactiveColor: "var(--semantic-color-background-interactive-data-vendor-terragrunt-inactive)",
  },
};
